import { Float } from "@Components/Decor";
import { useSelector } from "react-redux";
import { RootState } from "src/store";
import { MENU_ITEM_DECORS } from "../../constants";
import "./index.css";
import Box from "@Icons/MainIcons/Box";

export default function LandingHeroDecor() {
  const menuItems = useSelector((state: RootState) => state.client.menuItems);
  return (
    <div className="landing-hero-decor-fade pointer-events-none absolute inset-0" aria-hidden>
       <svg className="landing-hero-mesh text-border-subtle pointer-events-none absolute inset-0 h-full w-full" aria-hidden>
        <defs>
          <pattern id="landing-hero-box-mesh" width={100} height={100} patternUnits="userSpaceOnUse">
            <Box width={100} height={100} viewBox="0 0 5 5" fill="none" strokeWidth={.1} className="text-font-disabled"/>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#landing-hero-box-mesh)" />
      </svg>
      <div className="landing-hero-decor-glow absolute inset-0" />
      {(Object.keys(MENU_ITEM_DECORS) as (keyof typeof MENU_ITEM_DECORS)[]).map((type) => {
        const { main: Main, secondary: Secondary, doesExist, x, y, rotation, duration, delay, distance, className = "" } = MENU_ITEM_DECORS[type];
        return (
          <div key={type} className={`absolute max-md:hidden ${x} ${y} ${rotation} ${className}`}>
            <Float duration={duration} delay={delay} distance={distance}>
              {doesExist(menuItems) ? (
                <div className="origin-center max-lg:scale-40 lg:scale-65">
                  <Main />
                </div>
              ) : (
                <Secondary />
              )}
            </Float>
          </div>
        );
      })}
      <div className="landing-hero-decor-blur absolute inset-x-0 bottom-0 h-1/3 backdrop-blur-sm" />
    </div>
  );
}
